import zhLocal from './zh-CN';
import zhTWLocal from './zh-TW';
import enUSLocal from './en-US';
import itITLocal from './it-IT';
import { moduleConfig } from '@/core/config';

const locales = {
  'zh-CN': zhLocal,
  'zh-TW': zhTWLocal,
  'en-US': enUSLocal,
  'it-IT': itITLocal,
};

export type LocaleType = keyof typeof locales;

export default (
  locale?: LocaleType,
): {
  [key: string]: string;
} => {
  if (locale) {
    return locales[locale];
  }
  if (locales[moduleConfig.language]) {
    return locales[moduleConfig.language];
  }
  return locales['zh-CN'];
};
